"use client";

import { cn } from "@/lib/utils";
import { LockKeyhole } from "lucide-react";

export function PortalTrustNote({
  brokerName,
  message,
  compact = false,
}: {
  brokerName: string;
  message?: string;
  compact?: boolean;
}) {
  return (
    <div
      className={cn(
        "flex items-start gap-2 text-xs leading-5 text-muted-foreground",
        !compact &&
          "rounded-lg border border-border/70 bg-muted/30 px-3 py-2.5",
      )}
    >
      <LockKeyhole className="mt-0.5 h-3.5 w-3.5 shrink-0" aria-hidden />
      <span>
        {message ?? `Your details are only shared with ${brokerName}.`}
      </span>
    </div>
  );
}
